import { AutocompleteOption } from "../Components/Autocomplete/Type/AutocompleteTypes";

export interface MaterialSequenceLike {
  sequence?: number | null;
  name?: string | null;
  sku?: string | null;
}

export interface MaterialAutocompleteOption extends AutocompleteOption, MaterialSequenceLike {}

export function compareMaterialSequence(left: MaterialSequenceLike, right: MaterialSequenceLike): number {
  const sequenceCompare = Number(left.sequence ?? Number.MAX_SAFE_INTEGER) - Number(right.sequence ?? Number.MAX_SAFE_INTEGER);
  if (sequenceCompare !== 0) {
    return sequenceCompare;
  }

  const nameCompare = (left.name ?? "").localeCompare(right.name ?? "");
  if (nameCompare !== 0) {
    return nameCompare;
  }

  return (left.sku ?? "").localeCompare(right.sku ?? "");
}

export function sortByMaterialSequence<T>(items: T[], pickMaterial: (item: T) => MaterialSequenceLike): T[] {
  return [...items].sort((left, right) => compareMaterialSequence(pickMaterial(left), pickMaterial(right)));
}

export function toMaterialAutocompleteOption(material: {
  id: string;
  name: string;
  sku: string;
  sequence?: number | null;
}): MaterialAutocompleteOption {
  return {
    value: material.id,
    label: `${material.name} (${material.sku})`,
    sequence: Number(material.sequence ?? 0),
    name: material.name,
    sku: material.sku,
  };
}

export function mergeMaterialAutocompleteOptions(
  existing: MaterialAutocompleteOption[],
  incoming: MaterialAutocompleteOption[],
): MaterialAutocompleteOption[] {
  const optionMap = new Map<string, MaterialAutocompleteOption>();
  [...existing, ...incoming].forEach((option) => {
    optionMap.set(option.value.toString(), option);
  });

  return sortByMaterialSequence(Array.from(optionMap.values()), (option) => option);
}
